import React, { useEffect } from 'react';
import { SecurityBoundary, PermissionBoundary } from '@vehix/portal/lib/security';
import { logDataAccess } from '@vehix/portal/lib/security/audit';
import { SystemRole } from '@vehix/portal/types';
import { useAuth } from '@vehix/shared/admin/portal-bridge';
import { WorkflowManagementWrapper } from '../../components/WorkflowManagementWrapper';

const WorkflowManagementPage: React.FC = () => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      logDataAccess({
        resource: 'workflow_management',
        action: 'view',
        metadata: { page: 'workflow-management' }
      }).catch(() => {
        /* silent — audit logging should not surface errors */
      });
    }
  }, [user]);

  return (
    <SecurityBoundary
      requiredSystemRole={SystemRole.SUPER_ADMIN}
      auditPageAccess='workflow-management'
      tenantIsolation={false}
    >
      {/* Page-level title removed — sidebar nav already labels this page,
          matching the Setup-pages convention. The WorkflowManagementWrapper
          below provides its own internal tab strip which names the active
          view. */}
      <div className='flex h-full w-full flex-col space-y-6 overflow-hidden p-6'>
        <div className='flex min-h-0 flex-1 flex-col overflow-y-auto'>
          <PermissionBoundary require={{ resource: 'users', action: 'manage' }}>
            <WorkflowManagementWrapper hidePipelinesTab />
          </PermissionBoundary>
        </div>
      </div>
    </SecurityBoundary>
  );
};

export default WorkflowManagementPage;
